import { Component, Prop } from '@stencil/core';

@Component({
  tag: 'cwru-logos',
  styleUrl: 'logos.css',
  shadow: true,
})

export class LogoTypes {
  @Prop() logoType:  string;
}
